import React, { useCallback, useEffect, useRef, useState } from 'react';
import classNames from 'classnames';

const stages = {
  STAGE_1: 10,
  STAGE_2: 50,
  STAGE_3: 100,
};

interface UIProgressBarProps {
  percent?: number;
  withStaging?: boolean;
  containerClassName?: string;
  runningLineClassName?: string;
}

const UIProgressBar = ({
  percent = 0,
  withStaging = true,
  containerClassName,
  runningLineClassName,
}: UIProgressBarProps) => {
  const [dynamicalProgress, setDynamicalProgress] = useState(0);
  const timeoutRef = useRef<ReturnType<typeof setTimeout> | null>(null);
  const isMountedRef = useRef(false);

  const handleSetDynamicalProgress = useCallback(
    offset => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = null;
      }
      timeoutRef.current = setTimeout(() => {
        if (isMountedRef.current) {
          setDynamicalProgress(dynamicalProgress + offset);
        }
      }, 100);
    },
    [dynamicalProgress],
  );

  const setProgress = useCallback(() => {
    if (dynamicalProgress >= stages.STAGE_3) {
      setDynamicalProgress(stages.STAGE_3);
    } else if (percent < stages.STAGE_2 && dynamicalProgress > stages.STAGE_2) {
      setDynamicalProgress(stages.STAGE_2);
    } else if (percent === stages.STAGE_2 && dynamicalProgress < stages.STAGE_2) {
      handleSetDynamicalProgress(3);
    } else if (dynamicalProgress < stages.STAGE_2) {
      handleSetDynamicalProgress(0.5);
    } else if (dynamicalProgress < stages.STAGE_3) {
      handleSetDynamicalProgress(1.5);
    }
  }, [dynamicalProgress, handleSetDynamicalProgress, percent]);

  useEffect(() => {
    isMountedRef.current = true;
    return () => {
      isMountedRef.current = false;
    };
  }, []);

  useEffect(() => {
    if (withStaging) {
      setProgress();
    }
  }, [withStaging, setProgress]);

  return (
    <div className={classNames('progress-bar', containerClassName)}>
      <div
        className={classNames('progress-bar__filter', runningLineClassName)}
        style={{ width: `${withStaging ? dynamicalProgress : percent}%` }}
      />
    </div>
  );
};
export default UIProgressBar;
